// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentWrapper_wrapper__VDYgN"};